
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import instance from './instance';
import { API_VERSION_ONE } from './constants';
import { IDeals, ISLMTCarbonIntensityOptions, IUpdateDeal, type SaveKpiDataI } from '../types/types';

const fetchCarbonIntensityGridApi = `${API_VERSION_ONE}techsources?`;
const fetchCarbonIntensityNonGridApi = `${API_VERSION_ONE}techsourcesren?`;
const fetchCarbonIntensityForPipelineGasAsCommodityApi = `${API_VERSION_ONE}pipeline-gas-carbon-intensities/?`;
const fetchCarbonIntensityForRngAsCommodityApi = `${API_VERSION_ONE}rng-carbon-intensities/?`;
const fetchEvpApi = `${API_VERSION_ONE}evp`;
const fetchBusinessunitsApi = `${API_VERSION_ONE}businessunits`;
const fetchCommoditiesApi = `${API_VERSION_ONE}commodities`;
const fetchCountriesApi = `${API_VERSION_ONE}countries/?`;
const fetchRegionsApi = `${API_VERSION_ONE}regions`;
const fetchUnitofmeasuresApi = `${API_VERSION_ONE}unitofmeasures`;
const fetchGridLocationsApi = `${API_VERSION_ONE}powergrid/?`;
const fetchGasFiredPowerDataApi = `${API_VERSION_ONE}gasfiredpowercis/?`;
const saveKpiDataApi = `${API_VERSION_ONE}kpi-deal`;
const fetchTechSourcesApi = `${API_VERSION_ONE}get-technology-sources`;
const downloadKpiDealApi = `${API_VERSION_ONE}download-kpi-deal`;
const fetchAllDeals = `${API_VERSION_ONE}all-deals`;
const updateDeal = `${API_VERSION_ONE}update-deal/?`;
const deleteDeal = `${API_VERSION_ONE}delete-deal`;
const dealDetails = `${API_VERSION_ONE}deal-details/?`;
const netcarbonintensity = `${API_VERSION_ONE}netcarbonintensity`;
const fetchTSproductOptionsApi = `${API_VERSION_ONE}products`;
const fetchProductCarbonIntensitiesApi = `${API_VERSION_ONE}product-carbon-intensities/?`;
const fetchSLMTCarbonIntensitiesApi = `${API_VERSION_ONE}slmt-carbon-intensities/?`;
// SLMT-specific APIs
const fetchTypeOfSupplyByBusinessApi = `${API_VERSION_ONE}type-of-supply?`;
const fetchCountryAssetOfSupplyByTypeApi = `${API_VERSION_ONE}country-asset-of-supply?`;

interface ICarbonIntensityOptions {
  techSource: string[] | string;
  startYear: number;
  endYear: number;
  gridLocation: string;
}
interface IProductCarbonIntensityOptions {
  products: string[];
  region?: string | null;
  country?: string | null;
}

export const fetchCarbonIntensityGrid = (options: ICarbonIntensityOptions) => {
  const url = `${fetchCarbonIntensityGridApi}techSource=${options.techSource}&startYear=${options.startYear}&endYear=${options.endYear}&gridLocation=${options.gridLocation}`;
  return instance.get(url);
};

export const fetchCarbonIntensityNonGrid = (techSources: string[]) => {
  let allTechSourcesLink = '';
  for (const element of techSources) {
    allTechSourcesLink += `techSource=${element}&`;
  }
  allTechSourcesLink = allTechSourcesLink.substring(0, allTechSourcesLink.length - 1);
  const url = `${fetchCarbonIntensityNonGridApi}${allTechSourcesLink}`;
  return instance.get(url);
};

interface ICarbonIntensityOptionsForPipelineGasAsCommodity {
  region: string;
  country?: string;
  startYear: number;
  endYear: number;
}

export const fetchCarbonIntensityForPipelineGasAsCommodity = (
  options: ICarbonIntensityOptionsForPipelineGasAsCommodity,
) => {
  const url = `${fetchCarbonIntensityForPipelineGasAsCommodityApi}region=${options.region}&country=${options.country}&startYear=${options.startYear}&endYear=${options.endYear}`;
  return instance.get(url);
};

export const fetchCarbonIntensityForRngAsCommodity = (
  options: ICarbonIntensityOptionsForPipelineGasAsCommodity,
) => {
  const url = `${fetchCarbonIntensityForRngAsCommodityApi}region=${options.region}&startYear=${options.startYear}&endYear=${options.endYear}`;
  return instance.get(url);
};

export const fetchEvp = () => {
  const url = fetchEvpApi;
  return instance.get(url);
};

export const fetchBusinessunits = (evpId?: number) => {
  const url = evpId ? `${fetchBusinessunitsApi}/?evp_id=${evpId}` : fetchBusinessunitsApi;
  return instance.get(url);
};

export const fetchCommodities = () => {
  const url = fetchCommoditiesApi;
  return instance.get(url);
};

export const fetchTSproductOptions = () => {
  const url = fetchTSproductOptionsApi;
  return instance.get(url);
};

export const fetchCountries = (region: string) => {
  const url = `${fetchCountriesApi}region=${region}`;
  return instance.get(url);
};

export const fetchTechSources = () => {
  const url = `${fetchTechSourcesApi}`;
  return instance.get(url);
};

export const fetchRegions = () => {
  const url = fetchRegionsApi;
  return instance.get(url);
};
export const fetchUnitofmeasures = () => {
  const url = fetchUnitofmeasuresApi;
  return instance.get(url);
};

export const fetchGridLocations = (region: string, countryCode: string) => {
  const url = `${fetchGridLocationsApi}region=${region}&countryName=${countryCode}`;
  return instance.get(url);
};

interface IGasFiredPowerData {
  startYear: number;
  endYear: number;
}

export const fetchGasFiredPowerData = (options: IGasFiredPowerData) => {
  const url = `${fetchGasFiredPowerDataApi}startYear=${options.startYear}&endYear=${options.endYear}`;
  return instance.get(url);
};

export const saveKpiData = (options: SaveKpiDataI[]) => {
  const url = saveKpiDataApi;
  return instance.post(url, options);
};

export const downloadKpiData = () => {
  const url = downloadKpiDealApi;
  return instance.get(url);
};

export const getAllDeals = () => {
  const url = fetchAllDeals;
  return instance.get(url);
};

export const updateDeals = (options: IUpdateDeal) => {
  const { OPPORTUNITY_ID, MOVE_CARBON_DASHBOARD } = options;
  const url = `${updateDeal}opportunityId=${OPPORTUNITY_ID}&moveCarbonDashboard=${MOVE_CARBON_DASHBOARD}`;
  return instance.get(url);
};

export const deleteDeals = (deals: IDeals[]) => {
  const url = deleteDeal;
  return instance.post(url, deals);
};

export const getDealDetails = (opportunityId: number) => {
  const url = `${dealDetails}opportunityId=${opportunityId}`;
  return instance.get(url);
};

export const getNetCarbonIntensity = () => {
  const url = netcarbonintensity;
  return instance.get(url);
};

export const fetchProductCarbonIntensities = (options: IProductCarbonIntensityOptions) => {
  const productsParam = options.products.join(',');
  // Determine product types: include region for any non-FAME/ETHANOL product,
  // include country for any FAME/ETHANOL product. This allows sending both
  // when the product list contains a mix.
  const upperProducts = options.products.map((p) => String(p).toUpperCase());
  const hasFameOrEthanol = upperProducts.some((p) => p === 'FAME' || p === 'ETHANOL');
  const hasNonFame = upperProducts.some((p) => p !== 'FAME' && p !== 'ETHANOL');

  let url = `${fetchProductCarbonIntensitiesApi}products=${productsParam}`;
  if (hasNonFame && options.region) {
    url += `&region=${options.region}`;
  }
  if (hasFameOrEthanol && options.country) {
    url += `&country=${options.country}`;
  }
  return instance.get(url);
};

export const fetchSLMTCarbonIntensities = (options: ISLMTCarbonIntensityOptions) => {
  const url = `${fetchSLMTCarbonIntensitiesApi}countryAssetOfSupplyId=${options.countryAssetOfSupplyId}&tradeCommodityId=${options.commodityId}&startYear=${options.startYear}&endYear=${options.endYear}`;
  return instance.get(url);
};

export const fetchTypeOfSupplyByBusiness = (businessId: number) => {
  const url = `${fetchTypeOfSupplyByBusinessApi}businessId=${businessId}`;
  return instance.get(url);
};

export const fetchCountryAssetOfSupplyByType = (typeOfSupplyId: number) => {
  const url = `${fetchCountryAssetOfSupplyByTypeApi}typeOfSupplyId=${typeOfSupplyId}`;
  return instance.get(url);
};
